import config from "config/config";

export async function depricated_getPaymentUID(
  Amount,
  OrderId,
  BillingName,
  Portal,
  UserId,
  blockCode
) {
  let url =
    config.REG_API_BASE_URL +
    "/Payment/getpaymentuid?Amount=" +
    encodeURIComponent(Amount) +
    "&OrderId=" +
    encodeURIComponent(OrderId) +
    "&BillingName=" +
    encodeURIComponent(BillingName) +
    "&Portal=" +
    Portal +
    "&UserId=" +
    UserId +
    "&blockCode=" +
    blockCode;
  const response = await fetch(url, {
    headers: {
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  });
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
